import React from "react";

import styles from "../../../styles/Components/RolesPage/RoundCheckInput.module.css";

const RoundCheckInput = ({ 
    id, 
    label, 
    value, 
    checked, 
    handleChange,
    disabled = false
}) => {
    return (
        <label className={styles.rounded_check_input_label}>
            <input
                type="checkbox"
                id={id}
                value={value}
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
            />
            <span className={styles.new_checkbox} onClick={(e) => e.stopPropagation()} />
            {label}
        </label>
    );
};

export default RoundCheckInput;